import { IUiIcon } from '../../../types/ui'

export const IconIsBuyer = (
	{
		size = 24,
		imgSize = 24,
		fill = 'currentColor',
	}: IUiIcon
) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={`${size}px`}
		height={`${size}px`}
		viewBox={`0 0 ${imgSize} ${imgSize}`}
		fill={fill}
	>
		<path d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM17.4571 9.45711L16.0429 8.04289L11 13.0858L8.20711 10.2929L6.79289 11.7071L11 15.9142L17.4571 9.45711Z"></path>
	</svg>

	// <svg
	// 	xmlns="http://www.w3.org/2000/svg"
	// 	width="24"
	// 	height="24"
	// 	viewBox="0 0 24 24"
	// 	fill="currentColor"
	// >
	// 	<path d="M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5Z"></path>
	// </svg>

)